import { render, staticRenderFns } from "./ModalForAllocating.vue?vue&type=template&id=c2220aa4&"
import script from "./ModalForAllocating.vue?vue&type=script&lang=js&"
export * from "./ModalForAllocating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports